/* eslint-disable */
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import s from './originals.module.css';
import { Ico } from '../ShellIcons';
import { useUiStore } from '../../../stores/uiStore';
import OriginalsCompare from './OriginalsCompare';

// ============================================================
// OriginalsBulkBar — a selection raises the white pill (S3): N selected ·
// Compare · Export · Request dev · Set status / Assign to (editors — the
// legacy Bulk Edit Bar's two writes, unchanged) · clear. It reads the same
// uiStore.selectedItems the cards write (#141). Export opens the app's
// ExportModal pre-ticked to the selection; Request dev takes one original.
// ============================================================

export default function OriginalsBulkBar({ items, selectedItems, setSelectedItems, perm, fields, onBulkStatus, onBulkAssign }) {
  const setShowExport = useUiStore((st) => st.setShowExport);
  const setDevRequestItem = useUiStore((st) => st.setDevRequestItem);
  const [compare, setCompare] = useState(false);
  const n = selectedItems ? selectedItems.size : 0;
  const picked = n ? (items || []).filter((i) => selectedItems.has(i.id)) : [];
  const statusOpts = (fields || []).find((f) => f.key === 'status')?.options || [];
  const assignOpts = (fields || []).find((f) => f.key === 'assignedTo')?.options || [];
  const clear = () => setSelectedItems(new Set());
  const requestDev = () => { const one = picked[0]; if (one) setDevRequestItem(one); };

  return ReactDOM.createPortal(
    <>
      <div className={`${s.bulk} ${n ? s.on : ''}`} role="toolbar" aria-label="Selection" aria-hidden={!n} data-shell-pop data-test="originals-bulk-bar" onClick={(e) => e.stopPropagation()}>
        <b>{n} selected</b>
        <button type="button" onClick={() => setCompare(true)} disabled={n < 2} title={n < 2 ? 'Select two or more to compare' : 'Compare side by side'}><Ico name="compare" /><span>Compare</span></button>
        {perm?.canExport ? <button type="button" onClick={() => setShowExport(true)} title="Export the selection"><Ico name="download" /><span>Export</span></button> : null}
        <button type="button" onClick={requestDev} disabled={n !== 1} title={n === 1 ? 'Request a development from this original' : 'Select exactly one original'}><Ico name="pen" /><span>Request dev</span></button>
        {perm?.canEdit && statusOpts.length ? (
          <label className={s.pick} title="Set status"><Ico name="activity" /><span>Set status</span>
            <select value="" aria-label="Set status" onChange={(e) => { const v = e.target.value; if (v) onBulkStatus(v); }}><option value="">Set status…</option>{statusOpts.map((o) => <option key={o} value={o}>{o}</option>)}</select>
          </label>
        ) : null}
        {perm?.canEdit && assignOpts.length ? (
          <label className={s.pick} title="Assign to"><Ico name="user" /><span>Assign to</span>
            <select value="" aria-label="Assign to" onChange={(e) => { const v = e.target.value; if (v) onBulkAssign(v); }}><option value="">Assign to…</option>{assignOpts.map((o) => <option key={o} value={o}>{o}</option>)}</select>
          </label>
        ) : null}
        <button type="button" className={s.x} onClick={clear} aria-label="Clear selection" title="Clear selection"><Ico name="x" /></button>
      </div>
      {compare && n >= 2 ? <OriginalsCompare items={picked} onClose={() => setCompare(false)} /> : null}
    </>,
    document.body
  );
}
